"use client"
import { useEffect, useState } from "react";
import DropDown from "../DropDown/DropDown";
import MobileDropDown from "../MobileDropDown/MobileDropDown"; // Import the MobileDropDown component
import LogoWhite from "../../assets/logo-white.svg";
import Logo from "../../assets/Logo.svg";
import Link from "next/link";
import Image from "next/image";


const AppBar = ({ blok }) => {
  const [menuOpen, setMenuOpen] = useState(false); // To toggle the mobile menu
  const [openIndex, setOpenIndex] = useState(true); // To track the open dropdown

  const [{ useCaseData, Products, Solutions, Resources, AboutUs }, setData] = useState({
    useCaseData: [],
    Products: [],
    Solutions: [],
    Resources: [],
    AboutUs: []
  });

  // const [appBarContent,setAppBarContent] = useState([])

  const items = blok?.reference?.filter(item => item.name == "Navigation")?.[0]?.content?.global?.[0]?.Nav || [];

  const appBarContent = items.map(item => ({ name: item.name, heading: item.title }))

  const partnerData = items.find(item => item.name == "Partners");

  const partner = { name: partnerData?.title, url: partnerData?.link?.cached_url }

  useEffect(() => {
    const useCaseData = items.find(item => item.name == "Use Cases")?.Navitems?.map(item => ({
      icon: <img className="w-[70px] aspect-square object-contain" src={item.icon.filename} />,
      title: item.title,
      description: item.subtitle,
      link: item.url.cached_url
    }))

    const Products = items.find(item => item.name == "Products")?.Navitems?.map(item => ({
      icon: <img className="w-[70px] aspect-square object-contain" src={item.icon.filename} />,
      title: item.title,
      description: item.subtitle,
      link: item.url.cached_url
    }))

    const Solutions = items.find(item => item.name == "Solutions")?.Navitems?.map(item => ({
      icon: <img className="w-[70px] aspect-square object-contain" src={item.icon.filename} />,
      title: item.title,
      description: item.subtitle,
      link: item.url.cached_url
    }))

    const Resources = items.find(item => item.name == "Resources")?.Navitems?.map(item => ({
      icon: <img className="w-[70px] aspect-square object-contain" src={item.icon.filename} />,
      title: item.title,
      description: item.subtitle,
      link: item.url.cached_url
    }))

    const AboutUs = items.find(item => item.name == "About Us")?.Navitems?.map(item => ({
      icon: <img className="w-[70px] aspect-square object-contain" src={item.icon.filename} />,
      title: item.title,
      description: item.subtitle,
      link: item.url.cached_url
    }))
    setData({ useCaseData, Products, Solutions, Resources, AboutUs })
  }, [blok]);




  const toggleMenu = () => {
    setMenuOpen(!menuOpen); // Toggles the hamburger menu on mobile
  };

  const handleDropdownToggle = (index) => {
    setOpenIndex(openIndex === index ? null : index); // Toggle the dropdown for the given index
  };

  return (
    <nav
      className="lg:px-6 py-4 flex items-center justify-between lg:justify-around absolute w-full top-0"
      style={{
        zIndex: 50,
        backgroundColor: menuOpen ? "#6E27BE" : "transparent",
      }}
    >
      {/* Logo */}
      <div className="px-4 py-4 flex items-center justify-between relative gap-[71px] max-w-7xl w-full">
        <div className="hidden lg:flex items-center">
          <a href="/">
            <img
              src={menuOpen ? '/images/logo-white.svg' : '/images/Logo.svg'}
              alt="Securin"
              className="h-8"
              style={{ width: "fit-content" }}
            />
          </a>
        </div>
        {/* Menu Items (Desktop) */}
        <div className="hidden lg:flex lg:justify-center lg:items-center space-x-6">
          <DropDown
            label={appBarContent[0].name}
            items={Products}
            heading={appBarContent[0].heading}
          />
          <DropDown
            label={appBarContent[1].name}
            items={Solutions || []}
            heading={appBarContent[1].heading}
          />
          <DropDown
            label={appBarContent[2].name}
            items={useCaseData || []}
            heading={appBarContent[2].heading}
          />
          <Link
            href={"/" + partner.url}
            className="text-gray-800 hover:text-[#5A27E7] transition duration-150 font-semibold"
          >
            {partner.name}
          </Link>
          <DropDown
            label={appBarContent[4].name}
            items={Resources || []}
            heading={appBarContent[4].heading}
          />
          <DropDown
            label={appBarContent[5].name}
            items={AboutUs || []}
            heading={appBarContent[5].heading}
          />
        </div>
        {/* Right side buttons (Desktop) */}
        <div className="hidden lg:flex space-x-4">
          <Link href="https://app.securin.io/">
            <button
              aria-label="Login"
              className="bg-white border  border-[#E56717] text-[#E56717] px-4 py-2 rounded hover:bg-[#EF7B22] hover:text-white transition duration-150"
            >
              Login
            </button>
          </Link>
          <Link href="https://app.securin.io/register.html">
            <button
              aria-label="Sign Up"
              className="border  border-[#E56717]  bg-[#E56717] text-white px-4 py-2 rounded hover:bg-[#d7691d] transition duration-150"
            >
              Sign Up
            </button>
          </Link>
        </div>
        {/* Hamburger Menu (Mobile) */}
        <div className="lg:hidden flex items-center">

        </div>
        {/* Mobile Dropdown with Transition and Delay */}
        <div className="lg:hidden flex absolute w-full left-0 px-4 top-0 justify-between mb-10">
          <a href="/" className="">
            <img
              src={menuOpen ? '/images/logo-white.svg' : '/images/Logo.svg'}
              alt="Securin"
              className="h-8"
            />
          </a>
          <button
            aria-label="Menu Open and Close"
            onClick={toggleMenu}
            className={`text-2xl transition-all duration-300 ease-in-out transform ${menuOpen ? "rotate-180" : "rotate-0"
              }`}
            style={{ color: menuOpen ? "white" : "black" }}
          >
            {menuOpen ? "X" : "☰"}
          </button>
        </div>
        <div
          className={`${menuOpen ? "h-screen opacity-100" : "h-0 opacity-0"} 
                            lg:hidden fixed top-0 left-0 w-full bg-[#6E27BE] space-y-4
                             overflow-hidden transition-all duration-150 ease-in-out overflow-y-auto border-top-4
                              border-white`}
        >
          <div className="flex justify-between mb-10 p-[16px] ">
            <a href="/">
              <img
                src={menuOpen ? '/images/logo-white.svg' : '/images/Logo.svg'}
                alt="Securin"
                className="h-8"
              />
            </a>
            <button
              aria-label="Menu Open and Close"
              onClick={toggleMenu}
              className={`text-2xl transition-all duration-300 ease-in-out transform ${menuOpen ? "rotate-180" : "rotate-0"
                }`}
              style={{ color: menuOpen ? "white" : "black" }}
            >
              {menuOpen ? "X" : "☰"}
            </button>
          </div>
          <div className="mx-2 flex flex-col gap-5">
            <MobileDropDown
              label={appBarContent[0].name}
              items={Products}
              isOpen={openIndex === 0}
              onToggle={() => handleDropdownToggle(0)}
            />
            <MobileDropDown
              label={appBarContent[1].name}
              items={Solutions}
              isOpen={openIndex === 1}
              onToggle={() => handleDropdownToggle(1)}
            />
            <MobileDropDown
              label={appBarContent[2].name}
              items={useCaseData}
              isOpen={openIndex === 2}
              onToggle={() => handleDropdownToggle(2)}
            />
            <Link
              href={"/" + partner.url}
              className="block text-white border-2 border-white 
                    rounded-lg px-4 hover:text-gray-200  transition duration-150 font-normal py-2"
            >
              {partner.name}
            </Link>
            <MobileDropDown
              label={appBarContent[4].name}
              items={Resources}
              isOpen={openIndex === 4}
              onToggle={() => handleDropdownToggle(4)}
            />
            <MobileDropDown
              label={appBarContent[5].name}
              items={AboutUs}
              isOpen={openIndex === 5}
              onToggle={() => handleDropdownToggle(5)}
            />
          </div>
        </div>
      </div>
    </nav>
  );
};

export default AppBar;
